import { getImgUrl } from '@utils/functions/getImgUrl';
import Image from 'next/image';
import React from 'react';
import { SecondaryColor } from 'stories/Button.stories';
import { SlGraduation } from 'react-icons/sl';
import { AiOutlineUser } from 'react-icons/ai';
import { IoBookOutline } from 'react-icons/io5';

function TutorialCard({
  cardTitle,
  tags,
  cardImage,
  description,
  modules = {},
  views = 574,
  slug = '',
  modulesCount,
  lessonsCount,
}) {
  const totalLessons = getLessonsLength(modules?.data || []) || lessonsCount;

  return (
    <div className="flex flex-col gap-y-4 rounded-lg border border-[#E0E0E0] bg-white p-4">
      <div className="grid grid-cols-9 items-center gap-x-8">
        <div className="col-span-2 h-16 w-16">
          <Image
            src={getImgUrl(cardImage)}
            height={100}
            width={100}
            objectFit="contain"
            alt="Logo"
            className="rounded-2xl"
          />
        </div>
        <div className="col-span-7">
          <span className="font-satoshi-medium text-[14px] font-semibold leading-5 text-[#D80E32]">
            {tags?.[0]?.name || tags.data[0]?.attributes?.name}
          </span>
          <p className="font-satoshi-bold text-[20px] font-bold  leading-7">{cardTitle}</p>
        </div>
      </div>
      <p className="font-satoshi-medium text-[14px] leading-5 text-[#3D3D3D] line-clamp-3">
        {description}
      </p>
      <div className="flex items-center justify-between font-satoshi-medium">
        {(modules?.data?.length || modulesCount) && (
          <span className="flex items-center gap-x-2">
            <SlGraduation />
            <span className="text-[14px] leading-5 text-[#646464]">{`${
              modules?.data?.length || modulesCount
            } Modules`}</span>
          </span>
        )}

        <span className="flex items-center gap-x-2">
          <IoBookOutline />
          <span className="text-[14px] leading-5 text-[#646464]">{`${totalLessons} Lessons`}</span>
        </span>

        <span className="flex items-center gap-x-2">
          <AiOutlineUser />
          <span className="text-[14px] leading-5 text-[#646464]">{`${views} Learners`}</span>
        </span>
      </div>
      <SecondaryColor
        linkCTA
        href={`/bytes/tutorials/${slug}`}
        size={'medium'}
        label={'Start Learning'}
      />
    </div>
  );
}

export default TutorialCard;

export function getLessonsLength(data = []) {
  if (data.length === 0) {
    return 0;
  }

  const totalLessons = data.reduce((accu, curr) => {
    const { attributes = {} } = curr;

    accu += attributes?.lessons?.data?.length || 0;

    return accu;
  }, 0);

  return totalLessons;
}
